export const shouldCloseCreateTaskOnEscape = (
  event: Pick<KeyboardEvent, 'key' | 'defaultPrevented'>
): boolean => event.key === 'Escape' && !event.defaultPrevented;
